import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.limitElement = document.querySelector(".other-destinations")
    this.footerElement = document.querySelector("footer")

    if (this.limitElement) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.buttonTarget.classList.remove("fixed", "bottom-[20px]")
            this.buttonTarget.classList.add("absolute")
            this.buttonTarget.style.top =
              (this.limitElement.offsetTop - this.buttonTarget.offsetHeight - 20) + "px"
          } else {
            this.buttonTarget.classList.remove("absolute")
            this.buttonTarget.classList.add("fixed", "bottom-[20px]")
            this.buttonTarget.style.top = ""
          }
        })
      })

      this.observer.observe(this.limitElement)
    }

    // --- PATCH FOOTER (ULTRA MINIMAL) ---
    if (this.footerElement) {
      this.footerObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // disparaît dans le footer
            this.buttonTarget.classList.add("opacity-0", "pointer-events-none")
          } else {
            // redevient visible hors footer
            this.buttonTarget.classList.remove("opacity-0", "pointer-events-none")
          }
        })
      }, { threshold: 0.1 })

      this.footerObserver.observe(this.footerElement)
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.footerObserver) this.footerObserver.disconnect()
  }
}
